import { fetchCarHireOfferInsuranceQuote, getCarHireOfferInsuranceQuoteKey } from 'actions/CarHireActions'
import config from 'constants/config'
import GeoContext from 'contexts/geoContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useContext, useEffect } from 'react'

const EmptyState: App.CarHireOfferInsuranceQuoteInformationList = {
  data: undefined,
  fetching: false,
  error: undefined,
}

function useCarHireInsuranceQuote(params?: App.CarHireOfferInsuranceQuoteParams) {
  const dispatch = useAppDispatch()
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)
  const isCarHireInsuranceAvailableIncurrentRegion = config.CARHIRE_INSURANCE_REGIONS.split(',').includes(currentRegionCode)
  const isCarHireInsuranceAvailable = config.CARHIRE_INSURANCE_ENABLED
  const quoteKey = params ? getCarHireOfferInsuranceQuoteKey(params, currentCurrency, currentRegionCode) : ''

  const insuranceQuoteInfo = useAppSelector(state => state.carHire.offerInsuranceQuoteLists[quoteKey] ?? EmptyState)

  useEffect(() => {
    if (params && isCarHireInsuranceAvailableIncurrentRegion && isCarHireInsuranceAvailable) {
      dispatch(fetchCarHireOfferInsuranceQuote(params))
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isCarHireInsuranceAvailable, isCarHireInsuranceAvailableIncurrentRegion, params, quoteKey])

  return insuranceQuoteInfo
}

export default useCarHireInsuranceQuote
